import { render } from "./Step_two.vue?vue&type=template&id=012d5fe0"
import script from "./Step_two.vue?vue&type=script&lang=js"
export * from "./Step_two.vue?vue&type=script&lang=js"

import "./Step_two.vue?vue&type=style&index=0&id=012d5fe0&lang=less"
script.render = render

export default script